enum UiEventType {
    NONE                     = 'NONE',
    CAPTIONS_MENU_BUTTON_TAP = 'CAPTIONS_MENU_BUTTON_TAP',
    CAPTIONS_OPTION_TAP      = 'CAPTIONS_OPTION_TAP',
    FAST_FORWARD_TAP         = 'FAST_FORWARD_TAP',
    FULLSCREEN_TAP           = 'FULLSCREEN_TAP',
    PLAY_PAUSE_TAP           = 'PLAY_PAUSE_TAP',
    REWIND_TAP               = 'REWIND_TAP',
    FRAME_TAP                = 'FRAME_TAP',
    FRAME_MOUSE_ENTER        = 'FRAME_MOUSE_ENTER',
    FRAME_MOUSE_LEAVE        = 'FRAME_MOUSE_LEAVE',
    FRAME_MOUSE_MOVE         = 'FRAME_MOUSE_MOVE',
    FRAME_BLUR               = 'FRAME_BLUR',
    FRAME_FOCUS              = 'FRAME_FOCUS',
    SEEK_TO_LIVE_EDGE_TAP    = 'SEEK_TO_LIVE_EDGE_TAP',
    SETTINGS_CLOSE_TAP       = 'SETTINGS_CLOSE_TAP',
    TIMECODE_TAP             = 'TIMECODE_TAP',
    TIMELINE_INSPECT         = 'TIMELINE_INSPECT',
    TIMELINE_SCRUB           = 'TIMELINE_SCRUB',
    TIMELINE_TAP             = 'TIMELINE_TAP',
    VOLUME_SLIDER_TAP        = 'VOLUME_SLIDER_TAP',
    VOLUME_SLIDER_DRAG       = 'VOLUME_SLIDER_DRAG',
    VOLUME_SLIDER_DRAG_END   = 'VOLUME_SLIDER_DRAG_END',
    VOLUME_TAP               = 'VOLUME_TAP'
}

export default UiEventType;